export default __webpack_public_path__ + "static/media/no-banner.d0df35b7.png";